//@flow
import React from 'react';

import {makeStyles, MenuItem, TableCell} from '@material-ui/core';
import PillSelect from '../../../../../elements/PillSelect';
import {colors} from '../../../../../assets/styles/colors';

const useStyles = makeStyles(theme => ({
  selectField: {
    whiteSpace: 'nowrap',
    padding: '15px',
    borderRadius: '8px',
    height: '48px',
    color: colors.grey800,
    border: `1px solid ${colors.grey300}`,
    width: '100%',
  },
  filterItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '250px',
    borderBottom: `1px solid ${colors.grey200}`,
    padding: '0.75rem 1.5rem',

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  filterLabel: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: '.9rem',
  },
  customCheckbox: {
    borderRadius: '50%',
    width: '1.5rem',
    height: '1.5rem',
    border: `1.25px solid ${colors.grey400}`,
    background: 'white',

    '&[data-checked="true"]': {
      border: `6px solid ${colors.primary}`,
    },
  },
}));

export default function FaqCell() {
  const classes = useStyles();
  return (
    <TableCell align="right">
      <PillSelect
        label="Preguntas frecuentes	"
        variant="outlined"
        classes={{
          button: classes.selectField,
        }}
      >
        <MenuItem className={classes.filterItem}>
          <span className={classes.filterLabel}>Nombre</span>
          <span className={classes.customCheckbox} data-checked={true} />
        </MenuItem>

        <MenuItem className={classes.filterItem}>
          <span className={classes.filterLabel}>Nombre</span>
          <span className={classes.customCheckbox} />
        </MenuItem>
      </PillSelect>
    </TableCell>
  );
}
